import convertIncentivesToCosts from '../../../utils/convertIncentivesToCosts';
import filterIncentivesByTags from '../../../utils/filterIncentivesByTags';

export default function useIncentives({ myProject, incentives }) {
  const costs = myProject.flatMap((room) => room.upfront_costs);

  const incentivesAreReady = Boolean(incentives);
  const incentivesAsCosts = incentivesAreReady
    ? costs.flatMap((cost) => {
        const incentivesForThisCost = filterIncentivesByTags(
          incentives.incentives,
          cost.incentive_tags,
        );
        return convertIncentivesToCosts(incentivesForThisCost, cost);
      })
    : [];

  return { incentivesAreReady, incentivesAsCosts };
}
